<template>
  <div id="pageTable">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex sm12 style="text-align: right">
          <h3 style="float: left">Версии Приложения</h3>
          <v-btn color="blue" dark small fab @click="refresh()">
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn color="green" dark small fab @click="openEditingModal(-1)">
            <v-icon>add</v-icon>
          </v-btn>
        </v-flex>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                solo
                prepend-icon="search"
                placeholder="Поиск"
                v-model="search"
                hide-details
                class="hidden-sm-and-down"
              ></v-text-field>
              <v-btn
                v-if="!showDetailedSearch"
                @click="showDetailedSearch = true"
                icon
              >
                <v-icon>filter_list</v-icon>
              </v-btn>
              <v-btn
                v-if="showDetailedSearch"
                @click="clearDetailedSearch"
                icon
              >
                <v-icon>clear</v-icon>
              </v-btn>
            </v-toolbar>

            <v-slide-y-transition>
              <v-layout
                v-if="showDetailedSearch"
                style="padding-left: 25px; padding-right: 25px"
                card
                color="white"
              >
                <v-flex
                  v-for="dsOpt in detailedSearchOptions"
                  :key="dsOpt.searchKey"
                >
                  <v-text-field
                    flat
                    prepend-icon="search"
                    :placeholder="dsOpt.placeholder"
                    v-model="dsOpt.text"
                    hide-details
                    class="hidden-sm-and-down"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-slide-y-transition>

            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <v-data-table
                :headers="complex.headers"
                :search="search"
                :items="filteredItems"
                :rows-per-page-items="[10,25,50,100]"
                class="elevation-1"
                no-results-text="Нет результатов"
                rows-per-page-text="На странице"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.id }}</td>
                  <td>{{ props.item.version }}</td>
                  <td>{{ props.item.platform }}</td>
                  <td>{{ props.item.releaseDate }}</td>
                  <td>{{ props.item.releaseNotes }}</td>
                  <td>{{ props.item.isActive ? 'Да' : 'Нет' }}</td>
                  <td class="text-xs-right">
                    <v-btn
                      flat
                      icon
                      color="blue"
                      @click="openEditingModal(props.index)"
                    >
                      <v-icon>edit</v-icon>
                    </v-btn>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog v-model="editingModal" max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ editedIndex === -1 ? 'Новая версия' : 'Редактирование версии' }}</span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.version"
                  label="Версия"
                  :rules="[v => !!v || 'Обязательное поле']"
                ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-select
                  v-model="editedItem.platform"
                  :items="platformOptions"
                  label="Платформа"
                ></v-select>
              </v-flex>
              <v-flex xs12 sm6 md4>
                <v-text-field
                  v-model="editedItem.releaseDate"
                  label="Дата релиза"
                  type="date"
                ></v-text-field>
              </v-flex>
              <v-flex xs12>
                <v-textarea
                  v-model="editedItem.releaseNotes"
                  label="Описание релиза"
                ></v-textarea>
              </v-flex>
              <v-flex xs12>
                <v-switch
                  v-model="editedItem.isActive"
                  label="Активна"
                ></v-switch>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeEditingModal">Отмена</v-btn>
          <v-btn color="blue darken-1" flat @click="submit">Сохранить</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            search: '',
            showDetailedSearch: false,
            detailedSearchOptions: [
              {
                placeholder: "ID",
                searchKey: "id",
                text: ""
              },
              {
                placeholder: "Версия",
                searchKey: "version",
                text: ""
              },
              {
                placeholder: "Платформа",
                searchKey: "platform",
                text: ""
              },
            ],
            complex: {
                headers: [
                    {
                        text: "ID",
                        value: 'id'
                    },
                    {
                        text: "Версия",
                        value: 'version'
                    },
                    {
                        text: 'Платформа',
                        value: 'platform'
                    },
                    {
                        text: 'Дата релиза',
                        value: 'releaseDate'
                    },
                    {
                        text: 'Описание',
                        value: 'releaseNotes'
                    },
                    {
                        text: 'Активна',
                        value: 'isActive'
                    },
                    {
                        text: 'Действия',
                        value: 'actions',
                        sortable: false
                    }
                ],
            },
            editingModal: false,
            editedIndex: -1,
            editedItem: {
                id: null,
                version: '',
                platform: '',
                releaseDate: '',
                releaseNotes: '',
                isActive: true
            },
            defaultItem: {
                id: null,
                version: '',
                platform: '',
                releaseDate: '',
                releaseNotes: '',
                isActive: true
            },
            platformOptions: [
                { text: 'iOS', value: 'iOS' },
                { text: 'Android', value: 'Android' },
                { text: 'Web', value: 'Web' },
            ]
        };
    },

    mounted: function () {
        if (this.items.length === 0) {
          this.refresh();
        }
    },

    computed: {
        items () {
            return this.$store.getters['appVersions/items']
        },

        filteredItems() {
          let result = this.items;

          this.detailedSearchOptions.forEach(dsOpt => {
            if (dsOpt.text !== "") {
              result = result.filter(tsd => String(tsd[dsOpt.searchKey]).toLowerCase().indexOf(dsOpt.text.toLowerCase()) !== -1);
            }
          });

          return result;
        },
    },

    methods: {
        clearDetailedSearch() {
          this.detailedSearchOptions.forEach(s => (s.text = ""));
          this.showDetailedSearch = false;
        },

        refresh () {
            this.$store._actions['appVersions/loadItems'][0]();
        },

        openEditingModal (index) {
            this.editedIndex = index;
            if (index !== -1) {
                this.editedItem = Object.assign({}, this.items[index]);
            } else {
                this.editedItem = Object.assign({}, this.defaultItem);
            }
            this.editingModal = true;
        },

        closeEditingModal () {
            this.editingModal = false;
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        submit () {
            this.$store._actions['appVersions/save'][0]({
                data: this.editedItem,
                index: this.editedIndex
            });
            this.closeEditingModal();
        },
    }
};
</script>



// WEBPACK FOOTER //
// src/pages/ui/AppVersions.vue